import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { withValidator } from '../../validation/withValidator.js';
import { FEEDBACK_TYPES, SERVICE_DIRECTIONS } from './constants.js';
import { validatorObj } from './getObjectValidator.js';
export const FeedbackTypeField = JSX(({ field }) => {
    const feedbackType = field('feedbackType');
    useEffect(() => {
        if (feedbackType?.value?.key === 'FEEDBACK') {
            field('serviceDirection')?.onChange?.(SERVICE_DIRECTIONS[0]);
        }
    }, [feedbackType?.value]);
    return (_jsx(SelectControl, { label: "\u0422\u0435\u043C\u0430", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u043C\u0443", options: FEEDBACK_TYPES, ...withValidator(feedbackType, validatorObj.feedbackType) }));
});
//# sourceMappingURL=FeedbackTypeField.js.map